import React from 'react';
;;
import { Button, Column, Input } from 'src/ui/mui-ui-kit';;
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';
import Masonry from 'react-masonry-component';
import propTypes from 'prop-types';
import { UiFieldset, UiSelectAdapter } from 'src/ui';
import { PRICING_TABLE_DEFAULTS } from 'src/payment/const';

export class AccountPaymentTableForm extends React.Component {
  masonryRef = React.createRef();

  get vmdPaymentProducts() {
    const { paymentProducts, values } = this.props;

    if (paymentProducts.items) {
      const result = paymentProducts.items.filter(item => item.isVmd);

      return this.filterSelected(result, values.vmd);
    }
    return [];
  }

  get amexPaymentProducts() {
    const { paymentProducts, values } = this.props;

    if (paymentProducts.items) {
      const result = paymentProducts.items.filter(item => item.isAmex);

      return this.filterSelected(result, values.amex);
    }
    return [];
  }

  get cardServicesPaymentProducts() {
    const { paymentProducts, values } = this.props;

    if (paymentProducts.items) {
      const result = paymentProducts.items.filter(item => item.isCardServices);

      return this.filterSelected(result, values.cardServices);
    }
    return [];
  }

  handleAdd = fields => {
    fields.push({
      isEdit: true,
      category: fields.name,
    });
    this.masonryLayout();
  };

  handleCancel = fields => {
    fields.pop();
    this.masonryLayout();
  };

  handleSave = (fields, editing) => {
    const { id } = fields.value[editing].label;
    const label =
      fields.value[editing].label.label || fields.value[editing].label.name;

    fields.update(editing, {
      ...fields.value[editing],
      label,
      id,
      isEdit: false,
    });
    this.masonryLayout();
  };

  masonryLayout() {
    requestAnimationFrame(() => {
      const { current } = this.masonryRef;
      current.performLayout();
    });
  }

  filterSelected(items, selectedItems) {
    if (selectedItems && selectedItems.length) {
      return items.filter(
        product =>
          !selectedItems.find(addedProduct => addedProduct.id === product.id)
      );
    }
    return items;
  }

  render() {
    return (
      <UiFieldset title="Pricing">
        <Masonry
          disableImagesLoaded
          className="columns pricing-table is-edition"
          ref={this.masonryRef}
        >
          {PRICING_TABLE_DEFAULTS.map(table => (
            <FieldArray name={table.key} key={table.key}>
              {({ fields }) => {
                const editing = (fields.value || []).findIndex(
                  ({ isEdit }) => isEdit
                );
                const isEditing = editing > -1;
                let selectOptions;

                switch (table.key) {
                  case 'vmd':
                    selectOptions = this.vmdPaymentProducts;
                    break;
                  case 'amex':
                    selectOptions = this.amexPaymentProducts;
                    break;
                  case 'cardServices':
                    selectOptions = this.cardServicesPaymentProducts;
                    break;
                  default:
                    selectOptions = [];
                }

                return (
                  <Column
                    className="is-one-third-fullhd pricing-col"
                    isSize="1/2"
                  >
                    <h3 className="subtitle has-text-info is-5">
                      {table.title}
                    </h3>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Item</th>
                          {table.key !== 'cardServices' ? (
                            <th align="center">Per Item</th>
                          ) : (
                            <th align="center">Fee</th>
                          )}
                          {table.key !== 'cardServices' ? (
                            <th align="center">Rate</th>
                          ) : (
                            <th align="center">-----</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {fields.map((name, index) => (
                          <tr key={name}>
                            {editing === index ? (
                              <td>
                                <Field
                                  name={`${name}.label`}
                                  type="select"
                                  component={UiSelectAdapter}
                                  isCreatable
                                  components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                  }}
                                  options={selectOptions}
                                  getOptionValue={item => item.id || item.value}
                                  getOptionLabel={item =>
                                    item.name || item.label
                                  }
                                />
                              </td>
                            ) : (
                              <td>{fields.value[index].label}</td>
                            )}
                            <td align="center" className="has-text-info">
                              <Field
                                name={`${name}.perItem`}
                                type="number"
                                render={({ input }) => (
                                  <Input {...input} isSize="small" />
                                )}
                              />
                            </td>
                            {table.key !== 'cardServices' && (
                              <td align="center" className="has-text-info">
                                <Field
                                  name={`${name}.rate`}
                                  type="number"
                                  render={({ input }) => (
                                    <Input {...input} isSize="small" />
                                  )}
                                />
                              </td>
                            )}
                          </tr>
                        ))}
                        {isEditing ? (
                          <tr>
                            <td colSpan="3">
                              <div className="buttons">
                                <Button
                                  isSize="small"
                                  isColor="info"
                                  isOutlined
                                  className="is-rounded"
                                  onClick={() =>
                                    this.handleSave(fields, editing)
                                  }
                                  disabled={!fields.value[editing].label}
                                >
                                  Save
                                </Button>
                                <Button
                                  isSize="small"
                                  isColor="white"
                                  onClick={() => this.handleCancel(fields)}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <tr>
                            <td colSpan="3">
                              <Button
                                isSize="small"
                                isColor="info"
                                isOutlined
                                className="is-rounded"
                                onClick={() => this.handleAdd(fields)}
                              >
                                Add +
                              </Button>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </Column>
                );
              }}
            </FieldArray>
          ))}
        </Masonry>
      </UiFieldset>
    );
  }
}

AccountPaymentTableForm.propTypes = {
  paymentProducts: propTypes.object.isRequired,
  values: propTypes.object.isRequired,
};
